import {
    permissionLevelOwnerText,
    permissionLevelPublishingEditorText,
    permissionLevelEditorText,
    permissionLevelPublishingAuthorText,
    permissionLevelAuthorText,
    permissionLevelNoneditingAuthorText,
    permissionLevelReviewerText,
    permissionLevelContributorText,
    permissionLevelCustomText,
} from './permissionLevelLocaleStrings.locstring.json';
import { permissionLevelNoneText } from '../strings.locstring.json';
import loc from 'owa-localize';
import PermissionLevelType from 'owa-service/lib/contract/PermissionLevelType';

// Inteface where key is a permission level type and text is the localised value of that permission level type
export interface PermissionLevelToLocaleType {
    key: PermissionLevelType;
    text: string;
    disabled?: boolean;
}

export let getPermissionLevelToLocaleArray = function getPermissionLevelToLocaleArray() {
    let permissionLevelArray = [];
    permissionLevelArray.push({ key: 'Owner', text: loc(permissionLevelOwnerText) });
    permissionLevelArray.push({
        key: 'PublishingEditor',
        text: loc(permissionLevelPublishingEditorText),
    });
    permissionLevelArray.push({ key: 'Editor', text: loc(permissionLevelEditorText) });
    permissionLevelArray.push({
        key: 'PublishingAuthor',
        text: loc(permissionLevelPublishingAuthorText),
    });
    permissionLevelArray.push({ key: 'Author', text: loc(permissionLevelAuthorText) });
    permissionLevelArray.push({
        key: 'NoneditingAuthor',
        text: loc(permissionLevelNoneditingAuthorText),
    });
    permissionLevelArray.push({ key: 'Reviewer', text: loc(permissionLevelReviewerText) });
    permissionLevelArray.push({ key: 'Contributor', text: loc(permissionLevelContributorText) });
    permissionLevelArray.push({ key: 'None', text: loc(permissionLevelNoneText) });
    permissionLevelArray.push({
        key: 'Custom',
        text: loc(permissionLevelCustomText),
        disabled: true,
    });

    return permissionLevelArray;
};

// This array contains objects which maps permissionLevelType to the localised value of that permissionLevelType

/**
 * Get localised string of passed permission level type.
 * @param permissionLevelType A string from PermissionLevelType, which is union of predefined strings.
 * @return Localised text of permission level type.
 */
export function getPermissionLevelLocaleString(permissionLevelType: PermissionLevelType): string {
    const permissionLevelToLocaleObj = getPermissionLevelToLocaleArray().filter(
        permissionLevelLocaleItem => permissionLevelLocaleItem.key === permissionLevelType
    )[0];
    return permissionLevelToLocaleObj.text;
}
